/* ============================================================
   People's Peps collection pages.
   Behaviour for the PP Collection Header and PP Collection hero
   video sections.

   Customizer safety: the theme editor replaces one section's HTML
   in place and fires shopify:section:load. It does not reload the
   page and it does not re-run this file. So the global wiring below
   is document-level delegation behind a window guard, and the
   per-section work re-runs for the one section that reloaded.
   Nothing here binds a handler to a node it expects to survive.
   Kept in step with assets/pp-theme.js, which uses the same shape.
   ============================================================ */
(function () {
  if (window.__ppCollWired) return;
  window.__ppCollWired = true;

  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var reduced = function () { return mq('(prefers-reduced-motion: reduce)'); };

  /* ---------- sort control (delegated: survives any re-render) ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-pp-sort]') : null;
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.assign(u.toString());
  });

  /* ---------- hero video: source, pause control (delegated) ---------- */

  // Pick the encode for this screen and attach it. Phones and data-saver
  // browsers get the smaller file. Returns false when there is nothing to load.
  function attachSource(v) {
    if (!v || !v.dataset.srcHd) return !!(v && v.getAttribute('src'));
    var small = mq('(max-width: 759px)');
    var save = navigator.connection && navigator.connection.saveData;
    var want = (small || save) ? (v.dataset.srcSd || v.dataset.srcHd) : v.dataset.srcHd;
    if (v.getAttribute('src') !== want) v.src = want;
    return true;
  }

  // Run after the page has finished loading, so the video file never
  // competes with the poster still and the page's own images.
  function afterLoad(fn) {
    if (document.readyState === 'complete') { fn(); return; }
    window.addEventListener('load', fn, { once: true });
  }

  function setState(root, paused) {
    var b = root.querySelector('[data-pp-cvh-pause]');
    if (!b) return;
    b.setAttribute('aria-pressed', paused ? 'true' : 'false');
    b.setAttribute('aria-label', paused ? (b.dataset.labelPlay || 'Play video') : (b.dataset.labelPause || 'Pause video'));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pp-cvh-pause]') : null;
    if (!b) return;
    var root = b.closest('[data-pp-cvh]');
    var v = root && root.querySelector('video');
    if (!v) return;
    if (root.dataset.ppCvhWaiting === '1') {
      // Pressed before the video has started: honour it as a pause, so the
      // video does not start by itself once the page has loaded.
      root.dataset.ppCvhUserPaused = '1';
      delete root.dataset.ppCvhWaiting;
      setState(root, true);
      return;
    }
    if (v.paused) {
      attachSource(v);
      var q = v.play();
      if (q && q.then) { q.then(function () { setState(root, false); }, function () { setState(root, true); }); }
      else { setState(root, v.paused); }
    } else {
      v.pause();
      setState(root, true);
    }
  });

  /* ---------- per-section init ---------- */
  function initHero(root) {
    if (!root || root.dataset.ppCvhInit === '1') return;
    root.dataset.ppCvhInit = '1';
    var v = root.querySelector('video');
    if (!v) return;

    v.addEventListener('pause', function () { setState(root, true); });
    v.addEventListener('play', function () { setState(root, false); });
    // The video layer stays transparent over the poster still until it is
    // actually showing frames; on an error the still simply stays.
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    v.addEventListener('error', function () { v.classList.remove('is-playing'); setState(root, true); });

    if (reduced()) {
      // Readers who prefer reduced motion keep the still. Nothing is
      // downloaded unless they press play.
      v.preload = 'none';
      v.autoplay = false;
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (err) {}
      setState(root, true);
      return;
    }

    root.dataset.ppCvhWaiting = '1';
    afterLoad(function () {
      delete root.dataset.ppCvhWaiting;
      if (!v.isConnected || root.dataset.ppCvhUserPaused === '1') return;
      if (!attachSource(v)) return;
      v.autoplay = true;
      v.setAttribute('autoplay', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () { setState(root, v.paused); });
    });
  }

  function initSection(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pp-cvh]').forEach(initHero);
    if (root.matches && root.matches('[data-pp-cvh]')) initHero(root);
  }

  function initAll() { initSection(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  // Re-hydrate only the section the customizer just replaced.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pp-cvh]').forEach(function (el) {
      delete el.dataset.ppCvhInit; delete el.dataset.ppCvhWaiting; delete el.dataset.ppCvhUserPaused;
    });
    initSection(root);
  });

  // Stop playback when a section is removed in the editor.
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('video').forEach(function (v) { try { v.pause(); v.removeAttribute('src'); v.load(); } catch (err) {} });
  });
})();
